import { Skeleton } from '@/components/ui/skeleton';

export const ContactFormSkeleton = () => (
  <div className="space-y-6" data-testid="contact-form-skeleton">
    {[2, 1, 3, 3].map((columns, row) => (
      <div key={row} className="space-y-3">
        <Skeleton className="h-4 w-32" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {Array.from({ length: columns }, (_, column) => (
            <Skeleton key={column} className="h-10 w-full" />
          ))}
        </div>
      </div>
    ))}
  </div>
);
